import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import ButtonInput from "../../../../../components/common/Button/ButtonInput";
import FilterButton from "../../../../../components/common/Button/FilterButton";
import CustomDatePicker from "../../../../../components/common/DatePicker/CustomDatePicker";
import CustomTable from "../../../../../components/common/Table/CustomTable";
import TextInput from "../../../../../components/common/TextInput/TextInput";
import ExportButton from "../../../components/ExportButton";
import { cashColumns } from "../constants";

const CashTransaction = ({
  handleOutletButtonClick,
  handleDateChange,
  handleReset,
  loading,
  data,
  transactionTypeCount,
  handleTransactionTypeChange,
  handleEnter,
  handleExport,
  pageSizeValue,
  tablePagination,
  handleTableChange,
  handleInputChange,
  dateValue,
}) => {
  const [newData, setNewData] = useState([]);
  useEffect(() => {
    const temp = data.map(({ transactionProof, ...items }) => items)
    setNewData(temp)
  }, [data])
  return (
    <div className="py-3">
      <div className="d-flex filter-bar filter-bar-2">
        <TextInput
          id={"pageSize"}
          label={"Tampilkan"}
          width={"7%"}
          handleEnter={handleEnter}
          value={pageSizeValue}
          handleChange={handleInputChange}
        />
        <ButtonInput
          id={"outlet"}
          label={"Cabang/Outlet"}
          buttonText={"Pilih Cabang"}
          onButtonClick={handleOutletButtonClick}
          variant={"outline-secondary"}
          width={"13%"}
        />
        <CustomDatePicker
          id={"cashTransaction"}
          label={"Tanggal Transaksi"}
          isRangePicker
          width="20%"
          onInputChange={handleDateChange}
          value={dateValue}
        />
        <div className="ml-auto">
          <Button
            variant="link"
            className="btn-action btn-reset"
            onClick={handleReset}
          >
            Reset semua filter
          </Button>
        </div>
      </div>

      <div className="d-flex filter-bar-2 align-items-center mt-2 mb-4">
        <span style={{ fontSize: "15px" }}>Jenis Transaksi:</span>
        {transactionTypeCount.map((transactionCount) => {
          return (
            <FilterButton
              data={transactionCount}
              handleChange={handleTransactionTypeChange}
              type="transactionType"
            />
          );
        })}
      </div>

      <CustomTable
        columns={cashColumns()}
        data={data}
        loading={loading}
        handleTableChange={handleTableChange}
        pagination={tablePagination}
      />

      <div className="filter-bar-2 d-flex" style={{ marginTop: "2rem" }}>
        <ExportButton
          handleExport={handleExport}
          pathname="/history/cash/export"
          data={newData}
          from="cash"
          columns={cashColumns(false)}
        />
      </div>
    </div>
  );
};

export default CashTransaction;
